import React from 'react'
import { DatePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Grid, Menu, MenuItem, Typography,Button } from '@mui/material';
// import { Button } from 'react-bootstrap';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { useSelector } from 'react-redux';

const ExpiryDateFilter = ({
    onLoadData,open,anchorEl,handleClose,fromDate,toDate,setFromDate,setToDate,isVendorList,handleChange,type,showInvoiceType,showExpDate
}) => {
  const {authorized,permissionArr} = useSelector(state => state.auth)
  return (
    <>
         <Menu
      disableBackdropClick 
      disableEscapeKeyDown
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
             {showExpDate && (<Typography sx={{paddingLeft:'18px',paddingTop:'10px',paddingBottom:'10px'}} variant='h6'>Expiry Date:</Typography>)}
        <MenuItem
        disableTouchRipple
        disableRipple
      sx={{
        ":hover":{
          backgroundColor:"transparent"
        }
      }}
        >
                    {showExpDate && (
          <Grid container spacing={0}>
          <DemoContainer sx={{
          }} components={['DatePicker', 'DatePicker']}>
          <Grid item xs={12} sm={12}>
          <DatePicker
                  label="From Date"
                  value={fromDate}
                  onChange={(newValue) =>setFromDate(newValue)}
                />
          </Grid>
          <Grid item xs={12} sm={12}>
          <DatePicker
                  label="To Date"
                  value={toDate}
                  onChange={(newValue) => setToDate(newValue)}
                />
</Grid>
          </DemoContainer>
          </Grid>
          )}
        </MenuItem>
        <MenuItem
          disableTouchRipple
          disableRipple
         disableBackdropClick 
         disableEscapeKeyDown
         sx={{
          ":hover":{
            backgroundColor:"transparent"
          }
        }}
        >
<Grid container spacing={2}>
<Grid item xs={12} sm={12}>
  {showInvoiceType && (
    <FormControl         sx={{marginTop:'10px'}}
    fullWidth>
        <InputLabel id="demo-simple-select-label">Type</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={type}
          label="Type"
          onChange={handleChange}
        >
          <MenuItem value={"Telephone"}>Telephone</MenuItem>
          <MenuItem value={"Maintenance/Electricity"}>Maintenance/Electricity</MenuItem>
        </Select>
      </FormControl>
  )}
</Grid>
<Grid item xs={12} sm={12}>
<Button
        fullWidth
        disableRipple
        disableTouchRipple
        disableFocusRipple
        onClick={()=>{
          onLoadData()
        }}
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{
          textTransform:'none',
          backgroundColor:'#175AA9C7',
          color:"white",
          ":hover":{
            backgroundColor:'#175AA9C7',
          },
        }}
      >
        Apply
      </Button>
</Grid>
</Grid>
      </MenuItem>
      </Menu>
      </>
  )
}

export default ExpiryDateFilter